import { Component, inject } from '@angular/core';
import { DietSummaryService } from '../services/diet-summary.service';
import { AuthService } from 'projects/patient/src/app/core/auth/services/auth.service';
import { PreAssessment } from '../../user-const/user-model';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { Paging } from 'projects/patient/src/app/core/types/helper.model';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-diet-summary',
  imports: [CommonModule, ButtonModule, InfiniteScrollDirective],
  templateUrl: './diet-summary.component.html',
  styleUrl: './diet-summary.component.css',
})
export class DietSummaryComponent {
  patientID!: string;
  isLoading = false;
  hasMoreData = true;

  dietServices = inject(DietSummaryService);
  authService = inject(AuthService);
  assessmentSummary: PreAssessment[] = [];

  paging: Paging = {
    pageSize: 10,
    pageNumber: 1,
  };

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.authService.getUserProfile().subscribe((res) => {
      if (res && res.PatientId) {
        this.patientID = res.PatientId;
        this.getDietSummary(res.PatientId);
      }
    });
  }

  viewDietSummary(item: PreAssessment) {
    console.log('Open diet summary for:', item.id);
    this.router.navigate(['/diet-list'], { state: { assessment: item } });

    // navigate or call API
    // this.router.navigate(['/diet-summary', item.id])
  }

  getDietSummary(patientId: string) {
    if (this.isLoading || !this.hasMoreData) return;
    this.isLoading = true;
    this.dietServices.getAssessmentSummary(patientId, this.paging).subscribe({
      next: (res) => {
        // this.assessmentSummary = res.pre_assessment;

        if (res.pre_assessment.length === 0) {
          this.hasMoreData = false;
        }

        this.assessmentSummary = [...this.assessmentSummary, ...res.pre_assessment];
        console.log(this.paging.pageNumber);

        if (this.paging.pageNumber !== undefined) {
          this.paging.pageNumber++;
        }

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error fetching diet summary:', err);
        this.isLoading = false;
      },
    });
  }

  loadMore() {
    if (this.isLoading || !this.hasMoreData) return;

    console.log('Loading next page:', this.paging.pageNumber);

    this.getDietSummary(this.patientID);
  }
}
